import { useEffect, useState } from 'react'
import SuccessIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import Snackbar from '@mui/material/Snackbar'
import SnackbarContent from '@mui/material/SnackbarContent'
import makeStyles from '@mui/styles/makeStyles'
import { useSelector, useDispatch } from 'react-redux'
import { resetSnackbar } from './snackbar.actions'

const useStyles = makeStyles(theme => ({
  ERROR: {
    backgroundColor: `${theme.palette.error.dark} !important`,
  },
  SUCCESS: {
    backgroundColor: `${theme.palette.success.main} !important`,
  },
  INFO: {
    backgroundColor: `${theme.palette.info.main} !important`,
  },
  LOADER: {
    backgroundColor: `${theme.palette.info.main} !important`,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const icons = {
  ERROR: <WarningIcon style={{ marginRight: 10 }} />,
  INFO: <InfoIcon style={{ marginRight: 10 }} />,
  SUCCESS: <SuccessIcon style={{ marginRight: 10 }} />,
  LOADER: <CircularProgress style={{ marginRight: 10, color: 'white' }} />,
}

export const CVSSnackbar = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const currentMessage = useSelector(state => state.Snackbar)
  const showCloseIcon = currentMessage.type !== 'LOADER'

  useEffect(() => {
    if (!open) {
      dispatch(resetSnackbar())
    }
  }, [open])

  // Open the snackbar using the presence of a message.
  useEffect(() => {
    if (currentMessage?.message) {
      setOpen(true)
    }

    if (open && !currentMessage?.message) {
      setOpen(false)
    }
  }, [currentMessage?.message, open])

  // (Optionally) Control the status of the snackbar.
  useEffect(() => {
    if (currentMessage?.status === true) {
      setOpen(true)
    } else if (currentMessage?.status === false) {
      setOpen(false)
    }
  }, [currentMessage?.status])

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      autoHideDuration={currentMessage.duration}
      onClose={() => {
        setOpen(false)
      }}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
    >
      <SnackbarContent
        message={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {icons[currentMessage.type] || null}
            {currentMessage.message}
          </div>
        }
        className={classes[currentMessage.type]}
        action={
          currentMessage.action ? (
            <span
              onClick={() => {
                setOpen(false)
              }}
            >
              {currentMessage.action}
            </span>
          ) : (
            [
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                onClick={() => {
                  setOpen(false)
                }}
                size="large"
              >
                {showCloseIcon && <CloseIcon className={classes.icon} />}
              </IconButton>,
            ]
          )
        }
      />
    </Snackbar>
  )
}
